import JSZip from 'jszip';

const DOCX_NUMBERING_XML_PATH = 'word/numbering.xml';
const XML_NUMERIC_CHARACTER_REFERENCE_PATTERN = /&#(x[\da-f]+|\d+);/gi;
const NUMBERING_LEVEL_TEXT_VALUE_PATTERN =
  /(<(?:[A-Za-z_][\w.-]*:)?lvlText\b[^>]*\b(?:[A-Za-z_][\w.-]*:)?val=)(["'])([^"']*)\2/g;

export function decodeXmlNumericCharacterReferences(value: string) {
  return value.replace(XML_NUMERIC_CHARACTER_REFERENCE_PATTERN, (match, rawCodePoint) => {
    const codePoint =
      rawCodePoint[0]?.toLowerCase() === 'x'
        ? Number.parseInt(rawCodePoint.slice(1), 16)
        : Number.parseInt(rawCodePoint, 10);

    if (!Number.isFinite(codePoint)) return match;

    try {
      return String.fromCodePoint(codePoint);
    } catch {
      return match;
    }
  });
}

function normalizeNumberingXml(numberingXml: string) {
  return numberingXml.replace(NUMBERING_LEVEL_TEXT_VALUE_PATTERN, (match, prefix, quote, value) => {
    const decodedValue = decodeXmlNumericCharacterReferences(value);
    return decodedValue === value ? match : `${prefix}${quote}${decodedValue}${quote}`;
  });
}

export async function normalizeDocxNumberingXmlCharacterReferences(buffer: ArrayBuffer) {
  const zip = await JSZip.loadAsync(buffer);
  const numberingXmlEntry = zip.file(DOCX_NUMBERING_XML_PATH);
  if (!numberingXmlEntry) return buffer;

  const numberingXml = await numberingXmlEntry.async('string');
  const normalizedNumberingXml = normalizeNumberingXml(numberingXml);
  if (normalizedNumberingXml === numberingXml) return buffer;

  zip.file(DOCX_NUMBERING_XML_PATH, normalizedNumberingXml);
  return zip.generateAsync({ type: 'arraybuffer' });
}
